import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import PriorityHighOutlinedIcon from "@mui/icons-material/PriorityHighOutlined";

const ProformaHSCodeErrorDialog = ({ open, setOpen, setFocus, handleSubmit }) => {
  const handleClose = () => {
    setFocus(true)
    setOpen(false);
  };

  const handleCreate = () => {
    handleClose();
    handleSubmit();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <PriorityHighOutlinedIcon
          sx={{
            width: "60px",
            height: "60px",
            color: "var(--btnBgBlue)",
          }}
        />
      </DialogTitle>
      <DialogContent>
        Hs Kodu / GTIP - Gümrük Tarife Numarasını girmediniz! Bu sebeple takip numarası
        alamayabilirsiniz.
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCreate} className="iyzi-button-blue">
          Devam
        </Button>
        <Button onClick={handleClose} className="iyzi-button-blue">
          Düzenle
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProformaHSCodeErrorDialog;
